function GetPanels() {
  const panelSquares = window.panels.filter((x) => x.linkStatistic && x.linkStatistic !== '')
  const newPanels = window.sortByProp(panelSquares.filter((x) => x.new), 'title')
  const others = window.uniqueByProp(panelSquares, newPanels, 'title')
  return [...newPanels, ...window.sortByProp(others, 'title')]
}